import { sharedEnvironment } from './environment.shared';

export const environment = {
  ...sharedEnvironment,
  production: false,
  identityApiBaseUrl: 'https://api-dev.zepbazaar.com/api/v1',
  businessApiBaseUrl: 'https://api-dev.zepbazaar.com/api/v1',
  marketplaceApiBaseUrl: 'https://api-dev.zepbazaar.com/api/v1',
  chatSocketUrl: 'wss://api-dev.zepbazaar.com/api/v1/chats/ws',
};
